import { injectable } from 'tsyringe';
import dayjs from 'dayjs';

export const TOKEN_IWrapTime = Symbol('IWrapTime');

export interface IWrapTime {
    /**
     * Gets the current Unix timestamp in seconds plus additional hours
     * @param additionalHours - The number of hours to add to the current time
     * @returns The Unix timestamp in seconds after adding the specified hours
     */
    nowPlusHours(additionalHours: number): number;
    /**
     * Gets the current Unix timestamp in seconds
     */
    getCurrentUnixTimestamp(): number;
    internalDateOnlyAsString(date: number): string;
    fromUnixTimestampToRelativeString(date: number): string;
}

@injectable()
export class WrapTime implements IWrapTime {
    constructor() { }

    fromUnixTimestampToRelativeString = (epoch_ms: number): string => {
        return dayjs(epoch_ms).fromNow();
    }

    nowPlusHours(additionalHours: number): number {
        return dayjs().add(additionalHours, 'hour').valueOf();
    }

    public getCurrentUnixTimestamp = (): number => {
        return dayjs().valueOf();
    }

    public internalDateOnlyAsString = (date: number) => dayjs(date).format("YYYY-MM-DD");
}
